import React, { useEffect, useState } from 'react';
import { ZIMKitManager, Common } from '@zegocloud/zimkit-react';
import '@zegocloud/zimkit-react/index.css';
import Layout from "../../components/Layout/Layout";

function Chat() {
    const [appConfig, setAppConfig] = useState({
        appID: 1081005499,
        serverSecret: 'cd0476eade09a0ecf347b2005fdeedc8'
      })
    
      const [userInfo, setUserInfo] = useState({
        userID: 'MxL63i1X16NfhdTHV63IHxoJdEF2',
        userName: 'Zain',
        userAvatarUrl: 'https://storage.zego.im/IMKit/avatar/avatar-0.png'
      })


      useEffect(()=>{
        const loadUIKIT = async () => {
          const zimKit = new ZIMKitManager();
          const token = zimKit.generateKitTokenForTest(appConfig.appID, appConfig.serverSecret, userInfo.userID);
          await zimKit.init(appConfig.appID);
          await zimKit.connectUser(userInfo, token);
      }
      loadUIKIT();
      },[])


    return (
        <Layout title="Chat" pageTitle="chat">
              <div className="section">
                <Common></Common>
              </div>
        </Layout>
    );
}

export default Chat;